import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=4c626904&scoped=true&"
import script from "./brand.vue?vue&type=script&lang=js&"
export * from "./brand.vue?vue&type=script&lang=js&"
import style0 from "./brand.vue?vue&type=style&index=0&id=4c626904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c626904",
  null
  
)

export default component.exports